import * as Yup from "yup";


export const PotentialConsultantValidation = Yup.object({
  employeeCode: Yup.string().required("Employee code is required").min(1).max(50),
  firstName: Yup.string().required("First name is required").min(1).max(100),
  middleName: Yup.string().nullable().max(100),
  lastName: Yup.string().required("Last name is required").min(1).max(100),
  commonName: Yup.string().nullable().max(150),
  employeeTypeId: Yup.string().required("Employee type is required").uuid("Must be a valid UUID"),

  // Nullable/optional in both cases
  phoneNumber: Yup.string()
    .nullable()
    .length(12, "Does not match pattern +16049999999")
    .matches(/^\+\d{1,3}\d{7,14}$/, "Must include country code and area code, e.g. +16049999999"),
});

export const ConsultantValidation = Yup.object({
  employeeCode: Yup.string()
    .required("Employee code is required")
    .min(1)
    .max(50),

  firstName: Yup.string()
    .required("First name is required")
    .min(1)
    .max(100),

  middleName: Yup.string()
    .nullable()
    .max(100),

  lastName: Yup.string()
    .required("Last name is required")
    .min(1)
    .max(100),

  commonName: Yup.string()
    .nullable()
    .max(150),

  genderId: Yup.string()
    .required("Gender is required")
    .uuid("Must be a valid UUID"),

  companyEmail: Yup.string()
    .required("Company email is required")
    .email("Must be a valid email"),

  phoneNumber: Yup.string()
    .nullable()
    .length(12, "Does not match pattern +16049999999")
    .matches(
      /^\+\d{1,3}\d{7,14}$/,
      "Must include country code and area code, e.g. +16049999999"
    ),

  jobTitleId: Yup.string()
    .required("Job title is required")
    .uuid("Must be a valid UUID"),

  employeeTypeId: Yup.string().required("Employee type is required")
    .uuid("Must be a valid UUID"),

  managerId: Yup.string()
    .required("Manager is required")
    .min(1)
    .max(50),

  departmentId: Yup.string()
    .required("Department is required")
    .uuid("Must be a valid UUID"),

  officeLocationId: Yup.string()
    .required("Office location is required")
    .uuid("Must be a valid UUID"),

  hireDate: Yup.date()
    .required("Hire date is required")
    .typeError("Must be a valid date"),

  contractEndDate: Yup.date()
    .nullable()
    .typeError("Must be a valid date"),
});
